customElements.get("insider-collapsible-button") ||
  customElements.define(
    "insider-collapsible-button",
    class extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.dropdown = this.querySelector(".insider-collapsible-button-icons__dropdown");
        this.height = screen.height;
        this.addEventListener("click", () => {
          this.dropdown.classList.toggle("expanded"), this.classList.toggle("hide");
        });
        document.addEventListener("scroll", () => {
          scrollY > 2 * this.height
            ? (this.classList.add("hide"), this.dropdown.classList.remove("expanded"))
            : this.classList.remove("hide");
        });
      }
    },
  );
